/**
 * Main Product Page JavaScript - Laoli Theme
 * Main coordinator for product page functionality
 * Loads and initializes all specialized PDP modules
 */

document.addEventListener('DOMContentLoaded', function() {
  initMainProduct();
});

function initMainProduct() {
  const pdpWrapper = document.querySelector('.laoli-pdp');
  
  if (!pdpWrapper) {
    return;
  }

  // Initialize product variant selection (from pdp-select-secondary.js)
  if (typeof initPdpSelectSecondary === 'function') {
    initPdpSelectSecondary();
  } else {
    
  }
  
  // Initialize main PDP functionality (from pdp.js)
  if (typeof initPdp === 'function') {
    initPdp();
  } else {
    
  }
  
  // Initialize additional PDP features
  initProductStatus();
  
  // Initialize color dots for variant options
  if (typeof initColorDots === 'function') {
    // Small delay to ensure all variant elements are loaded
    setTimeout(() => {
      initColorDots();
    }, 100);
  } else {
    
  }
}

/**
 * Initialize product status based on variant availability
 */
function initProductStatus() {
  const pdpWrapper = document.querySelector('.laoli-pdp');
  const statusElements = document.querySelectorAll('.js-status');
  
  if (!pdpWrapper || !statusElements.length) {
    return;
  }

  const madeToOrderText = pdpWrapper.getAttribute('data-madeToOrderText');
  const inStockText = pdpWrapper.getAttribute('data-inStockText');
  const soldOutText = pdpWrapper.getAttribute('data-soldout');

  // Check if any variants are in stock  
  const variants = document.querySelectorAll('.laoli-pdp-mobile-info-buttons-sizes-menu-item[data-id]');
  let hasInStockVariant = false;

  variants.forEach((variant, index) => {
    // Check if variant has the 'empty' class which indicates it's out of stock
    const isEmpty = variant.classList.contains('laoli-pdp-mobile-info-buttons-sizes-menu-item_empty');
    
    if (!isEmpty) {
      hasInStockVariant = true;
    }
  });

  // Update status text only if we haven't already set it in pdp-select.js
  statusElements.forEach((status, index) => {
    // Only update if status hasn't been set by variant selection
    if (!status.hasAttribute('data-status')) {

      
      if (hasInStockVariant) {
        status.textContent = inStockText;
      } else {
        status.textContent = madeToOrderText;
      }
    } else {

    }
  });
}



// Export functions for use in other scripts if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    initMainProduct,
    initProductStatus
  };
}
